import { AccountConfigModule } from '@abp/ng.account/config';
import { CoreModule, LocalizationPipe } from '@abp/ng.core';
import { registerLocale } from '@abp/ng.core/locale';
import { ThemeBasicModule } from '@abp/ng.theme.basic';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/_services/auth.service';
import { environment } from 'src/environments/environment';
import { NgxsModule } from '@ngxs/store';
// Highlight JS
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
// import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
// import { FakeAPIService } from './_fake/fake-api.service';
// #fake-end#

// import ngx-translate and the http loader
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {HttpClient } from '@angular/common/http';

import { CurrencyPipe } from '@angular/common';
import { LayoutUtilsService } from './core/layout-utils.service';
// import { SubheaderService } from './_metronic/partials/layout';
import { OverlayModule } from '@angular/cdk/overlay';
// import { LayoutModule } from './pages/layout.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getGermanPaginatorIntl } from './modules/shared/german-paginator';

import { AuthConfig, OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { WebshopModule } from './modules/webshop/webshop.module';

import * as $ from 'jquery';

export function authAppInitializerFactory(authService: AuthService): () => Promise<void> {
  return () => authService.runInitialLoginSequence();
}


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    // SplashScreenModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    HighlightModule,
    ClipboardModule,
    CoreModule.forRoot({
      environment,
      registerLocaleFn: registerLocale(),
    }),
    ThemeSharedModule.forRoot(),
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    NgxsModule.forRoot(),
    ThemeBasicModule.forRoot(),

    // LayoutModule,
    OAuthModule.forRoot(),


    // // #fake-start#

    // HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
    //   passThruUnknownUrl: true,
    //   dataEncapsulation: false,
    // }),
    
    // // #fake-end#
    WebshopModule
  
  ],
  providers: [
   
    {
      provide: APP_INITIALIZER,
      useFactory: authAppInitializerFactory,
      multi: true,
      deps: [AuthService],
    },
    { provide: AuthConfig, useValue: environment.oAuthConfig },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
          json: () => import('highlight.js/lib/languages/json')
        },
      },
    },

    { provide: MatPaginatorIntl, useValue: getGermanPaginatorIntl() },

    // SubheaderService,
    // MenuHorizontalService,
    // MenuAsideService,
    // HttpUtilsService,
    // TypesUtilsService,
    LayoutUtilsService,
    LocalizationPipe,
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}